import React from 'react'

import { Link } from 'react-router-dom'

import { reverse } from 'routes'
import CircularIcon from 'components/CircularIcon'

import './style.scss'


export default function Confirmation (props)  {
  return (
    <div className="PasswordRecovery__confirmation">
      <CircularIcon icon="email" />
      <h4>Revisa tu correo</h4>
      <p className="paragraph-text paragraph-small">
        Te hemos enviado un correo con las instrucciones para recuperar tu contraseña
      </p>
      <Link to={reverse('accounts:login')} replace className="Button btn btn-inverse ">
        Iniciar sesión
      </Link>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/scenes/PasswordRecovery/components/Confirmation/index.js